import React, { useRef } from 'react';
import { TabMenuContainer } from './styles';
import ComplexPage from '../../containers/ComplexDocumentDesign/ComplexPage';
import { CONTEXT_KEYS } from '../../context/complexArtboardContext';
import ComplexArtboardProvider from '../../context/complexArtboardContext';
import ComplexTextEditingProvider from '../../context/complexTextEditingContext';
const OVERRIDE_ARTBOARD_STATE = {
  [CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN]: false,
  [CONTEXT_KEYS.ENABLE_RULER]: false,
  [CONTEXT_KEYS.RULER_WIDTH_ADJUSTER]: true,
  [CONTEXT_KEYS.DND_FLOW]: false,
  [CONTEXT_KEYS.SCALING_SETTING]: 0.3,
  [CONTEXT_KEYS.CURRENT_DESIGN]: 'document',
  [CONTEXT_KEYS.IS_DOC_TO_MAIL]: true,
};

const DocumentFlowsTemplate = ({ flows }) => {
  const visibilityRef = useRef(null);
  return (
    <TabMenuContainer ref={visibilityRef}>
      <ComplexArtboardProvider customState={OVERRIDE_ARTBOARD_STATE}>
      <ComplexTextEditingProvider>
        {flows.map((flow, flowNumber) => (
          <>
            <ComplexPage
              key={`${flow}-${flowNumber}`}
              uuid={flow}
              flowNumber={flowNumber}
              totalPages={flows.length}
              scaling={0.3}
              isVisible={true}
              visibilityRef={visibilityRef?.current}
            />
          </>
        ))}
      </ComplexTextEditingProvider>
      </ComplexArtboardProvider>
    </TabMenuContainer>
  );
};

export default DocumentFlowsTemplate;
